import getRole from "./RoleService";

const uri = `${import.meta.env.VITE_BASE_URL}/api`;

const StatisticalPost = async (
  creator,
  foundation,
  linkResult,
  status,
  createdAtFrom,
  createdAtTo
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const active = 1;
      const queryParams = new URLSearchParams({
        creator,
        foundation,
        linkResult,
        status,
        createdAtFrom,
        createdAtTo,
        active,
      }).toString();

      const response = await fetch(
        `${uri}/report/get-totals-amount?${queryParams}`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

export { StatisticalPost };
